import React from 'react';
import classNames from 'classnames';
import StyledLabel from '../../styled-label';

const namespace = 'ui-pdp-verified-vehicles-tag';

/**
 * Generates the content for a verified badge.
 *
 * @param {Object} label - The label object containing properties for the badge.
 * @param {boolean} clickable - Determines if the badge should be clickable.
 * @returns {JSX.Element} The styled label component with the appropriate classes and properties.
 */
export function getVerifiedBadgeContent(label, clickable) {
  return (
    <StyledLabel
      className={classNames(`${namespace}__verified-badge`, {
        clickable,
        [`${label.classname}`]: label.classname,
      })}
      {...label}
    />
  );
}
